import { jsx } from "react/jsx-runtime";
import { cn } from "@tameeni/shared-logic";
import React__default, { Children } from "react";
const FormLayoutContainer = ({ className, children }) => {
  const hasAsideContent = Children.toArray(children).some(
    (child) => React__default.isValidElement(child) && child.type === FormLayoutContainer.AsideContent
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "box mx-auto flex flex-col xl:grid gap-x-16 xl:gap-y-8 pt-8",
        hasAsideContent ? "xl:grid-cols-3" : "xl:grid-cols-1",
        className
      ),
      children
    }
  );
};
FormLayoutContainer["MainContent"] = ({ children, className }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "xl:col-span-2 flex flex-col gap-8 order-2 xl:order-1",
      className
    ),
    children
  }
);
FormLayoutContainer["MainContentHeaderWrapper"] = ({ children, className }) => /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-2 xl:col-span-2", className), children });
FormLayoutContainer["MainContentHeading"] = ({ children, className }) => /* @__PURE__ */ jsx("h1", { className: cn("text-h2 xl:text-h1 text-slate-900", className), children });
FormLayoutContainer["MainContentDesc"] = ({ children, className }) => /* @__PURE__ */ jsx(
  "p",
  {
    className: cn(
      "text-b3 xl:text-b1 text-slate-600 xl:max-w-[70%]",
      className
    ),
    children
  }
);
FormLayoutContainer["AsideContent"] = ({ children, className, sticky }) => /* @__PURE__ */ jsx(
  "aside",
  {
    className: cn(
      "flex flex-col gap-8 xl:col-span-1 order-1 xl:order-2",
      sticky && "xl:sticky xl:top-24 xl:self-start",
      className
    ),
    children
  }
);
FormLayoutContainer["MainContent"].displayName = "MainContent";
FormLayoutContainer["AsideContent"].displayName = "AsideContent";
FormLayoutContainer["MainContentDesc"].displayName = "MainContentDesc";
FormLayoutContainer["MainContentHeading"].displayName = "MainContentHeading";
FormLayoutContainer["MainContentHeaderWrapper"].displayName = "MainContentHeaderWrapper";
export {
  FormLayoutContainer
};
